var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-table-list" }, [
    _c("table", { attrs: { id: "table-list" } }, [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function(column) {
            return _c("th", { key: column.key }, [
              _c("div", { staticClass: "table-header" }, [
                _c("span", [
                  _vm._v(
                    "\n              " + _vm._s(column.text) + "\n            "
                  )
                ]),
                _vm._v(" "),
                _vm.isUseSort && column.sort
                  ? _c(
                      "div",
                      {
                        staticClass: "table-header-sort",
                        on: {
                          click: function($event) {
                            _vm.handleSorting(column)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-chevron-up",
                          class: {
                            active:
                              _vm.activeColumn === column.key && _vm.sort === 1
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-chevron-down",
                          class: {
                            active:
                              _vm.activeColumn === column.key && _vm.sort === -1
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ])
          })
        )
      ]),
      _vm._v(" "),
      _c("tbody", [_vm._t("table-body")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13e613b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e613b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/jTableList.vue
// module id = null
// module chunks = 